export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PHONE_DISPLAY = "79895 67909";
export const PHONE_TEL = "tel:+917989567909";
export const WHATSAPP_URL =
  "https://wa.me/917989567909?text=" +
  encodeURIComponent(
    "Hi! I'd like to book a vehicle inspection with Syed's Pro Drive Inspection."
  );
export const MAPS_URL = "https://maps.app.goo.gl/RYbVSkhu7As6LxJs6";
export const SITE_URL = "https://syeds-pro-drive.grexa.site";

export const SERVICES = [
  "Pre Delivery Inspection (PDI)",
  "Used Car Inspection",
  "Accident Damage Inspection",
  "Flood Damage Inspection",
  "Engine & Transmission",
  "OBD Computer Diagnostics",
];

export const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
